<template>
  <div id="app">
    <div class="router-wraper">
      <router-view/>
    </div>
    
  </div>
</template>

<script>
import {mapActions,mapState, mapMutations} from 'vuex'
import {accountApiUrl} from '../src/config'
export default {
  name: 'App',
  data(){
    return {
    }
  },
  created(){

  },
  mounted(){
    document.title = this.$t('WPS') + ' | beta'
    window.$ua = this.getOS()
    window._dw = window._dw || {}
    // var search = window.location.search.slice(1)
    // var searchArr = search.split("&").filter(item => item)
    // var query = {}
    // searchArr.map(item => {
    //   var kv = item.indexOf("=") >= 0 ? item.split("=") : []
    //   query[kv[0]] = kv[1]
    // })
    let upEvent = _dw.onEvent
    let that = this
    _dw.onEvent = function(event,data){
      // 数据统计debug
      // let flag = localStorage.getItem('debug')
      // let cf = JSON.parse(localStorage.getItem('dw_store_config'))
      // if (flag === 'true') {
      //     var aTag = document.createElement('a');
      //     var blob = new Blob(['']);
      //     let date = new Date()
      //     aTag.download = `accountid_${cf.accountId}_event_${event}_${date.getFullYear()}_${date.getMonth()+1}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}`;
      //     aTag.href = URL.createObjectURL(blob);
      //     aTag.click();
      //     URL.revokeObjectURL(blob)
      // }
      if (/disablecollectinfo=1/.test(location.href.toLowerCase())) {
        return
      }
      upEvent && upEvent(event,{
        from: window.cefQuery ? 'wps' : 'web',
        ...data
      })
    }
    window.addEventListener('contextmenu',(e) => {
      e.preventDefault()
    })
    this.loadConfig()
  },
  computed:{
    ...mapState([
      'toastCount',
      'toastMsg',
      'toastType',
    ]),
    ...mapState('user',[
      'id'
    ])
  },
  methods:{
    ...mapActions([
      "loadConfig"
    ]),
    getOS(){
         let BrowserDetect = {
            init: function () {
                this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
                this.version = this.searchVersion(navigator.userAgent)
                    || this.searchVersion(navigator.appVersion)
                    || "an unknown version";
                this.OS = this.searchString(this.dataOS) || "an unknown OS";
            },
            searchString: function (data) {
                for (var i=0;i<data.length;i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1)
                            return data[i].identity;
                    }
                    else if (dataProp)
                        return data[i].identity;
                }
            },
            searchVersion: function (dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
            },
            dataBrowser: [
                {
                    string: navigator.userAgent,
                    subString: "Chrome",
                    identity: "Chrome"
                },
                {   string: navigator.userAgent,
                    subString: "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity: "OmniWeb"
                },
                {
                    string: navigator.vendor,
                    subString: "Apple",
                    identity: "Safari",
                    versionSearch: "Version"
                },
                {
                    prop: window.opera,
                    identity: "Opera",
                    versionSearch: "Version"
                },
                {
                    string: navigator.vendor,
                    subString: "iCab",
                    identity: "iCab"
                },
                {
                    string: navigator.vendor,
                    subString: "KDE",
                    identity: "Konqueror"
                },
                {
                    string: navigator.userAgent,
                    subString: "Firefox",
                    identity: "Firefox"
                },
                {
                    string: navigator.vendor,
                    subString: "Camino",
                    identity: "Camino"
                },
                {       // for newer Netscapes (6+)
                    string: navigator.userAgent,
                    subString: "Netscape",
                    identity: "Netscape"
                },
                {
                    string: navigator.userAgent,
                    subString: "MSIE",
                    identity: "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string: navigator.userAgent,
                    subString: "Gecko",
                    identity: "Mozilla",
                    versionSearch: "rv"
                },
                {       // for older Netscapes (4-)
                    string: navigator.userAgent,
                    subString: "Mozilla",
                    identity: "Netscape",
                    versionSearch: "Mozilla"
                }
            ],
            dataOS : [
                {
                    string: navigator.platform,
                    subString: "Win",
                    identity: "Windows"
                },
                {
                    string: navigator.platform,
                    subString: "Mac",
                    identity: "Mac OS X"
                },
                {
                      string: navigator.userAgent,
                      subString: "iPhone",
                      identity: "iPhone/iPod"
                },
                {
                    string: navigator.platform,
                    subString: "Linux",
                    identity: "Linux"
                }
            ]

          };
          BrowserDetect.init();
          return BrowserDetect
    }
  },
  watch:{
    toastCount(cur){
      this.$message[this.toastType](this.$t(this.toastMsg))
    },
    id(cur){
        if (cur && !/disablecollectinfo=1/.test(location.href.toLowerCase())) {
            _dw.setAppKey('da375dedfadf11fb') //【必填】调用此方法，传入你产品的唯一标识
            .setDebug(false) //在调试时开启为true,线上环境请务必开启为false
            .setAccountId(String(this.id)) //设置账户id
            .setChannel("wps_oversea_cloud") //设置渠道
            .setVersion(this.$route.query.ver || 'web_2.0') //设置版本

            _dw.onEvent('drive_pageview_loadtime', {
                load_time: (new Date()).getTime() - window.startTime,
                type: 'drive',
                origin: this.$route.query.from || "drive"
            })
            window.dataLayer && window.dataLayer.push({
              event: 'drive_pageview_loadtime',
              from: this.$route.query.from ? this.$route.query.from : this.$route.query.cb ? this.$route.query.cb :'none'
            })
        }
    }
  },

}
</script>

<style>
@import './assets/css/reset.css';
.router-wraper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.checkbox {
    cursor: pointer;
    position: absolute;
    white-space: nowrap;
    outline: 0;
    line-height: 1;
    border: 1px solid #bfcbd9;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 1;
    left: 0;
    top: 50%;
    margin-top: -7px;
    display: none;
}
.checkbox:after {
    width: 3px;
    height: 6px;
    left: 4px;
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(1);
    transform-origin: center;
}
.selected  [class*=checkbox]{
    visibility: visible;
    background: #2e68f8;
    border-color: #2e68f8;
}
.night-mode{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 1000000;
}
/* list menu */
.list-actions{
    position: absolute;
    right: 0;
    min-width: 200px;
    top: 36px;
    padding: 0 4px 4px;
    font-size: 12px;
    background: #fff;
    border: 1px solid #d3d3d3;
    box-shadow: 0 2px 12px 0 rgba(56,56,56,.2);
    border-radius: 2px;
    color: #626b84;
}
.list-actions:hover{
    color: #626b84;
}
.list-action-title{
    text-indent: 6px;
    border-bottom: 1px solid #f3f6f9;
}
.list-action-item{
    white-space: nowrap;
    margin-top: 4px;
    text-align: left;
    font-size: 12px;
    
}
.list-action-inner{
  padding: 0 30px 0 36px;
  line-height: 30px;
  cursor: pointer;
}
.list-action-item.divided{
  border-top: 1px solid #f3f6f9;
}
.list-action-item.divided .list-action-inner{
  margin-top: 4px;
}
.list-action-inner:hover{
    background: #f7f9fc;
}
.list-action-item.checked{
    color: #2e68f8;
}
.list-action-item.checked .components-icons-check{
    display: inline-block;
}
.list-action-item .components-icons-check{
    vertical-align:text-bottom;
    font-size: 16px;
    display: none;
}
.list-checked{
    width: 36px;
    height: 30px;
    text-align: center;
    margin-left: -32px;
}
.list-name,.list-checked{
    display: inline-block;
    vertical-align: top;
}
.list-action-title{
    line-height: 30px;
}

.drive-file-container{
    flex: 1;
    flex-direction: column;
    display: flex;
    padding: 24px 0;
    margin-left: 42px;
    min-width: 0;
}
.cloud-aside{
  flex: 0 0 230px;
  display: flex;
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue